// removed by extract-text-webpack-plugin
module.exports = {"modal-overlay-div":"src-components-BaseModal-___styles__modal-overlay-div___t9yY-","modal-content-div":"src-components-BaseModal-___styles__modal-content-div___1fuMo","modal-dialog-div":"src-components-BaseModal-___styles__modal-dialog-div___2nZJ6","disclaimerText":"src-components-BaseModal-___styles__disclaimerText___2WeYZ","backupWithholdingQuestion":"src-components-BaseModal-___styles__backupWithholdingQuestion___32x0J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseModal/styles.css
// module id = 1045
// module chunks = 3